import { AVAILABLE_LANGUAGES } from "shared/const/languages";
import { Language } from "./types";

export const isSupportedLanguage = (lang: string): lang is Language => {
    return Object.values(AVAILABLE_LANGUAGES).some(language => language.id.toLowerCase() === lang.toLowerCase());
};